import { withNamespace } from "@/i18n/lazy-route"

/** Webhooks (LLD §9.7, Task 3.5), with the `webhooks` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/webhooks.json"),
  fr: () => import("@/i18n/locales/fr/webhooks.json"),
}

export const WebhooksScreen = withNamespace(
  "webhooks",
  () => import("./screens/WebhooksScreen"),
  translations,
)
export const WebhookDetailScreen = withNamespace(
  "webhooks",
  () => import("./screens/WebhookDetailScreen"),
  translations,
)
